import {
  Box,
  Center,
  CenterProps,
  CircularProgress,
  CloseButton,
  Image,
} from '@chakra-ui/react';
import { ReactNode } from 'react';
import { DropzoneState } from 'react-dropzone';

export interface UploaderProps {
  dropzone: DropzoneState;
  src?: string;
  enable?: boolean;
  uploading?: boolean;
  onDelete?: () => void;
  children: ReactNode;
  overlay?: ReactNode;
}

export function ImageUploader({
  dropzone,
  children,
  onDelete,
  src,
  uploading = false,
  enable = true,
  overlay,
  ...props
}: UploaderProps & CenterProps) {
  return (
    <Box
      position="relative"
      sx={{
        '&:hover > button': {
          opacity: 1,
        },
      }}
      {...props}
    >
      <Center
        height="100%"
        width="100%"
        position="relative"
        overflow="hidden"
        flexDir="column"
        {...dropzone.getRootProps()}
        cursor={enable && uploading ? 'not-allowed' : 'default'}
      >
        <input
          {...dropzone.getInputProps({
            accept: 'image/*',
          })}
          data-testid="hidden-upload-input"
        />
        {!src && children}
        {src && <Image w="100%" height="100%" src={src} objectFit="cover" />}
        <Center
          pos="absolute"
          top={0}
          right={0}
          bottom={0}
          left={0}
          className="image-upload-cover-overlay"
          opacity={0}
          _hover={{
            opacity: 1,
          }}
        >
          {overlay}
        </Center>
        {uploading && (
          <CircularProgress position="absolute" size="24px" isIndeterminate />
        )}
      </Center>
      {src && onDelete && (
        <CloseButton
          opacity={0}
          position="absolute"
          top="-10px"
          right="-10px"
          variant="circle"
        />
      )}
    </Box>
  );
}
